import React, {Fragment, useCallback, useEffect, useState} from 'react';
import axios from "axios";
import {API_BASE_URL} from "../config";
import {NavLink} from "react-router-dom";
import 'rc-slider/assets/index.css';
import SearchBar2 from "./SearchBar2";
import TimeInput from "./TimeInput";
import ProductivityProjectDropdown from "./Productivity/ProductivityProjectDropdown";
import {toast, ToastContainer} from "react-toastify";

const Tasks = ({
                   autoFocus,
                   searchBar,
                   searchLabel,
                   title,
                   onChanged,
                   tasks: initialTasks,
                   headers,
                   headersData,
                   fetchTasks
               }) => {

    const [durationLighting, setDurationLighting] = useState(false);
    const [users, setUsers] = useState([]);
    const [datasFound, setDatasFound] = useState(initialTasks);
    const [isVisible, setIsVisible] = useState(true);
    const [currentDay, setCurrentDay] = useState(null);
    const [tasks, setTasks] = useState(initialTasks || []);

    const [selectedTaskIds, setSelectedTaskIds] = useState([]);
    const [bulkUserId, setBulkUserId] = useState('');
    const [isBulkWorking, setIsBulkWorking] = useState(false);
    const [bulkFinishDate, setBulkFinishDate] = useState('');

    const toggleRow = (id) => {
        setSelectedTaskIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
    };

    useEffect(() => {
        axios.post(`${API_BASE_URL}/get_users`).then(res => setUsers(res.data));
    }, []);

    const handleBulkFinishDateChange = (value) => {
        if (!value || selectedTaskIds.length === 0) return;
        setBulkFinishDate(value);                 // keep it visible in the bar
        handleFinishDate(selectedTaskIds, value); // reuses your existing function
    };

    const handleBulkAssignChange = async (userId) => {
        if (!userId || selectedTaskIds.length === 0) return;
        setIsBulkWorking(true);
        setBulkUserId(userId); // keep selected user in the dropdown
        try {
            await handleUserChange(selectedTaskIds, userId); // supports arrays
            // DO NOT clear selectedTaskIds; keep them checked
            // DO NOT reset bulkUserId; keep selection visible
        } catch (e) {
            console.error('Bulk assign error:', e);
        } finally {
            setIsBulkWorking(false);
        }
    };

    const handleBulkFinish = async () => {
        if (currentDay === 0 || currentDay === 6) {
            alert('On ne remplit pas ses tâches le week-end ;)');
            return;
        }
        if (selectedTaskIds.length === 0) return;

        setIsBulkWorking(true);
        try {
            await Promise.all(selectedTaskIds.map(id => axios.post(`${API_BASE_URL}/update_task_progress`, {
                taskId: id, progress: 100, taskName: tasks.find(t => t.id === id)?.title || '',
            })));

            // optimistic update
            setTasks(prev => prev.map(t => selectedTaskIds.includes(t.id) ? ({...t, progress: 100}) : t));
            setDatasFound(prev => prev.map(t => selectedTaskIds.includes(t.id) ? ({...t, progress: 100}) : t));

            setSelectedTaskIds([]);
            onChanged?.();
        } catch (e) {
            console.error('Bulk finish error:', e);
            setDurationLighting(true);
        } finally {
            setIsBulkWorking(false);
        }
    };


    useEffect(() => {

        // Au début, on initialise les tâches trouvées avec les tâches passées en param au composant
        setDatasFound(initialTasks)
        setTasks(initialTasks);
        // Set the current day of the week (0 = Sunday, 6 = Saturday)
        const today = new Date().getDay();
        setCurrentDay(today);
        axios.post(`${API_BASE_URL}/get_users`)
            .then(res => {
                const {data} = res;
                if (data && data.length > 0) {
                    const userNamesArray = data.map(user => user);
                    setUsers(userNamesArray);

                } else {
                    console.error('No user data received');
                }
            })
            .catch(error => {
                console.error('Error fetching user data:', error);
            });
    }, [initialTasks]);

    const handleFinishDate = (tasksId, newDate) => {
        const updatedTaskIds = Array.isArray(tasksId) ? tasksId : [tasksId];
        updatedTaskIds.forEach(taskId => {

            const parsedDate = new Date(newDate);
            if (parsedDate.getTime() > Date.now()) {
                alert("La date de fin ne peut pas être dans le futur.");
                return;
            }

            axios.post(`${API_BASE_URL}/update_task_finish_date`, {time: newDate, id_task: taskId})
                .then(e => {
                    setTasks(prevTasks => {
                        const updatedTasks = prevTasks.map(task => task.id === taskId ? {
                            ...task, finished_at: newDate
                        } : task);
                        setDatasFound(updatedTasks); // Synchronize with datasFound
                        return updatedTasks;
                    });
                })
                .catch(error => {
                    console.error("Error updating task finish date:", error);
                });

        })
    };
    const handleFinishDateCustom = (tasksId, newDate) => {
        const updatedTaskIds = Array.isArray(tasksId) ? tasksId : [tasksId];
        updatedTaskIds.forEach(taskId => {
            axios.post(`${API_BASE_URL}/update_task_finish_date_custom`, {time: newDate, id_task: taskId})
                .then((res) => {
                    console.log(tasks)

                    console.log(res.data)
                    if (res.status === 200) {

                        setTasks(prevTasks => {
                            const updatedTasks = prevTasks.map(task => task.id === taskId ? {
                                ...task, start_date: newDate
                            } : task);
                            setDatasFound(updatedTasks); // Synchronize with datasFound
                            return updatedTasks;
                        });
                        // TODO Check que le focus soit dehors du calendrier avant de balancer le toast
                        //toast.success("La date de fin a été sauvegardée avec succès.")

                    } else {
                        toast.error("Erreur lors de la modification de la date de fin")
                    }

                })
                .catch(error => {
                    console.error("Error updating task finish date custom:", error);
                });
        });
    };

    const handleUserChange = (tasksId, userId) => {
        const updatedTaskIds = Array.isArray(tasksId) ? tasksId : [tasksId]; // Ensure tasksId is an array

        updatedTaskIds.forEach(taskId => {

            setTasks(prevTasks => {
                const updatedTasks = prevTasks.map(task => task.id === taskId ? {...task, user_id: userId} : task);
                setDatasFound(updatedTasks); // Synchronize with datasFound
                return updatedTasks;
            });

            axios.post(`${API_BASE_URL}/update_user_task`, {
                user_id: userId, task_id: taskId, admin_id: localStorage.user_id
            })
                .then((res) => {
                    console.log(res)
                    if (res.status !== 200) { // Revert the optimistic update if the API call fails
                        setTasks(prevTasks => {
                            const updatedTasks = prevTasks.map(task => task.id === taskId ? {
                                ...task, user_id: null
                            } : task);
                            setDatasFound(updatedTasks); // Synchronize with datasFound
                            toast.error("Erreur lors de l'assignation de l'utilisateur")
                            return updatedTasks;
                        });
                    } else {
                        toast.success("Personne attribuée avec succès.")
                    }
                })
                .catch(error => {
                    console.error('Error updating user task:', error);
                    // Revert the optimistic update if the API call fails
                    setTasks(prevTasks => prevTasks.map(task => task.id === taskId ? {
                        ...task, user_id: null // Assuming `null` reverts the assignment
                    } : task));
                });
        });
    };

    const formatDateForInput = (date, formatForDisplay = false, isDateTime = false) => {
        if (!date) {
            return formatForDisplay ? 'jj/mm/aaaa hh:mm:ss' : '';  // Placeholder based on context
        }

        const d = new Date(date);
        if (isNaN(d.getTime())) {
            return formatForDisplay ? 'jj/mm/aaaa hh:mm:ss' : '';  // Placeholder for invalid date
        }

        const day = d.getDate().toString().padStart(2, '0');
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const year = d.getFullYear();
        const hours = d.getHours().toString().padStart(2, '0');
        const minutes = d.getMinutes().toString().padStart(2, '0');
        const seconds = d.getSeconds().toString().padStart(2, '0');

        if (formatForDisplay) {
            // For display format (jj/mm/yyyy hh:mm:ss)
            return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
        } else if (isDateTime) {
            // For datetime-local input (yyyy-MM-ddTHH:mm:ss)
            return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
        } else {
            return `${year}-${month}-${day}`;  // For date input (yyyy-MM-dd)
        }
    };
    const handleTimeSpent = (user, time, id) => {

        const updatedTaskIds = Array.isArray(id) ? id : [id];
        updatedTaskIds.forEach(taskId => {

            axios.post(`${API_BASE_URL}/update_time_spent`, {user, time, id_task: id})
                .then(() => {
                    setTasks(prevTasks => {
                        const updatedTasks = prevTasks.map(task => updatedTaskIds.includes(task.id) ? {
                            ...task, time_spent: time
                        } : task);
                        setDatasFound(updatedTasks); // Synchronize with datasFound
                        return updatedTasks;
                    });
                    fetchTasks(); // Refresh tasks from the server
                })
                .catch(error => {
                    console.error("Error updating task finish date:", error);
                });

        })
    }

    useEffect(() => {
        if (durationLighting) {
            alert(durationLighting);
            setDurationLighting(false); // Reset the state after showing the alert
        }
    }, [durationLighting]);


    const handleProgressChange = (taskId, value, title) => {
        // 1) Garde-fou week-end
        if (currentDay === 0 || currentDay === 6) {
            alert('On ne remplit pas ses tâches le week-end ;)');
            return;
        }

        try {
            axios
                .post(`${API_BASE_URL}/update_task_progress`, {
                    taskId, progress: value, taskName: title,
                })
                .then(res => {
                    if (res.status !== 'ok') {
                        onChanged();
                    }
                })

            ;

        } catch (e) {
            console.error('Error updating task progress:', e);
            setDurationLighting(true);
        }

        window.location.reload()
    };

    return <div className={"bg-white"}>
        <ToastContainer position="bottom-right" autoClose={3000}/>

        {/* Barre de titre */}
        {title && (<div className="toggle-button mb-20 border-radius-5" onClick={() => setIsVisible(!isVisible)}>
            {title}
        </div>)}


        {isVisible && (<>
            {/* Barre de recherche */}
            {searchBar && (<SearchBar2
                autoFocus={autoFocus}
                totalPositionsLength={datasFound}
                datasFound={setDatasFound}
                totalDatas={initialTasks}
                datas={initialTasks}
                searchLabel={searchLabel}
            />)}
        </>)}
        <div className={"overflow-auto p-0"}>
            <div className="toggle-container">
                {isVisible && <div className="show p-20">


                    <table className="ticket-table">
                        <thead>
                        <tr>

                            {headers.map((header, index) => <th className={"text-left"} key={index}
                                                                id={header}>{header}</th>)}

                        </tr>
                        </thead>
                        <tbody>
                        {datasFound !== undefined && (

                            datasFound.map((item, rowIndex) => <tr key={rowIndex}>

                                {headersData.map((header, colIndex) => {

                                    if (header === 'name_1') {
                                        return (<td key={colIndex}>
                                            <a
                                                href={`/client/${item.contact_id}`}
                                                className="text-decoration-none text-left"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                {item.name_1}
                                                <p>{item.name_2}</p>
                                            </a>
                                        </td>);
                                    }
                                    if (header === 'customer') {
                                        return (<td key={colIndex}>
                                            <a
                                                href={`/client/${item.contact_id}`}
                                                className="text-decoration-none text-left"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                <p>{item.name_1}</p>
                                                <p>{item.name_2}</p>
                                            </a>
                                        </td>);
                                    }
                                    if (header === 'edit') {
                                        return (<td key={colIndex}>
                                            <div
                                                className={"cursor-pointer p-5-10 text-center border-radius-5 tasks-btn-edit"}
                                                style={{backgroundColor: "orange"}}
                                                onClick={() => handleProgressChange(item.id, 0, item.title)}>

                                                <i className={"fa-regular fa-pencil"}/>

                                            </div>
                                        </td>);
                                    }
                                    if (header === 'estimated_duration') {

                                        const totalMinutes = parseInt(item.estimated_duration, 10); // Ensure it's treated as a number

                                        // Calculate hours and remaining minutes
                                        const hours = Math.floor(totalMinutes / 60); // Divide total minutes by 60 to get hours
                                        const minutes = totalMinutes % 60; // Get the remainder as minutes

                                        // Format as HH:MM
                                        const formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;

                                        return (<td key={colIndex}>
                                            <p className={''}>{formattedTime}</p>
                                        </td>);
                                    }


                                    if (header === 'time_spent_reporting') {
                                        const timeParts = item.time_spent.split(':'); // Split time string by ':'
                                        const hours = parseInt(timeParts[0], 10); // Get hours
                                        const minutes = parseInt(timeParts[1], 10); // Get minutes

                                        // Build the time string based on hours and minutes
                                        let displayTime = '';
                                        if (hours > 0) {
                                            displayTime += `${hours} h`; // Pluralize 'heure' if necessary
                                        }
                                        if (minutes > 0) {
                                            if (hours > 0) displayTime += ' '; // Add space between hours and minutes
                                            displayTime += `${minutes} min`; // Pluralize 'minute' if necessary
                                        }

                                        return (<td key={colIndex} style={{minWidth: "100px", textAlign: "left"}}>
                                            {displayTime}
                                        </td>);
                                    }


                                    if (header === 'task_price_prorata') {
                                        return (<td key={colIndex}>
                                            {new Intl.NumberFormat('de-CH', {
                                                style: 'currency', currency: 'CHF'
                                            }).format(item.task_price_prorata)}
                                        </td>);
                                    }


                                    if (header === 'username_reporting') {
                                        return (<td key={colIndex}>

                                            {item.firstname}
                                        </td>);
                                    }
                                    if (header === 'title_finished' || header === 'title') {
                                        return (<td key={colIndex}>
                                            <NavLink
                                                to={`/positions/${item.position_id}`}
                                                className="text-decoration-none text-left"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                <strong>
                                                    {item.title}

                                                </strong>

                                            </NavLink>
                                        </td>);
                                    }
                                    if (header === 'title_open_position') {
                                        return (<td key={colIndex}>

                                            <strong>
                                                {item.title}

                                            </strong>

                                        </td>);
                                    }
                                    if (header === 'checkbox') {
                                        const isChecked = selectedTaskIds.includes(item.id);
                                        return (<td key={colIndex}>
                                            <input
                                                type="checkbox"
                                                checked={isChecked}
                                                onChange={() => toggleRow(item.id)}
                                                aria-label={`Select ${item.title}`}
                                            />
                                        </td>);
                                    }
                                    if (header === 'finished_at') {
                                        return (<td key={colIndex} className={''}>
                                            <span>{formatDateForInput(item.finished_at, true)}</span>
                                        </td>);
                                    }
                                    if (header === 'username') {
                                        return (<td>
                                            {localStorage.user_role ? (<select
                                                className={"input "}
                                                style={{
                                                    minWidth: 110, padding: "10px 5px", fontFamily: "Montserrat"
                                                }}
                                                onChange={(e) => {
                                                    handleUserChange(item.id, e.target.value);
                                                }}
                                                value={item.user_id || ""} // Ensure correct value is set, empty string for "Non assigné"
                                            >
                                                <option value="">Non assigné</option>
                                                {/* Option for "Non assigné" */}
                                                {users.map((user) => (<option key={user.id} value={user.id}>
                                                    {user.username}
                                                </option>))}
                                            </select>) : (<div>
                                                {item.username || "Non assigné"} {/* Display "Non assigné" if item.username is null */}
                                            </div>)}
                                        </td>);
                                    }
                                    if (header === 'username_ended') {
                                        return (<td>
                                            {item.firstname}

                                        </td>);
                                    }
                                    if (header === 'progress') {
                                        return (<td key={colIndex} className="">
                                            {((parseInt(localStorage.user_id)) === parseInt(item.user_id) || localStorage.user_role === 'Administrateur') && (
                                                <div
                                                    className={"cursor-pointer p-5-10 text-center border-radius-5 tasks-btn-finish tasks-btn"}
                                                    onClick={() => handleProgressChange(item.id, 100, item.title)}>
                                                    <i className={"fa-regular fa-check"}/>
                                                </div>)}

                                        </td>);
                                    }
                                    if (header === 'intern_name') {
                                        return (<td key={colIndex}>
                                            <span className={""}>{item.intern_name}</span>
                                        </td>);
                                    }
                                    if (header === 'finish_date_reporting') {
                                        const finishDate = new Date(item.finish_date);  // Parse the finish_date string into a Date object
                                        const formattedDate = `${finishDate.getDate().toString().padStart(2, '0')}/${(finishDate.getMonth() + 1).toString().padStart(2, '0')}/${finishDate.getFullYear()}`;

                                        return (<td key={colIndex}>
                                                        <span>
                                                            {formattedDate}
                                                        </span>
                                        </td>);
                                    }
                                    if (header === 'finish_date_custom') {
                                        const finishDate = new Date(item.start_date);  // Parse the finish_date string into a Date object
                                        let formattedDate = `${finishDate.getDate().toString().padStart(2, '0')}/${(finishDate.getMonth() + 1).toString().padStart(2, '0')}/${finishDate.getFullYear()}`;

                                        return (<td>
                                            <div className={'input-time-container'}>
                                                {localStorage.user_role === 'Administrateur' ?

                                                    <input
                                                        className={'input-time input'}
                                                        type={"datetime-local"}
                                                        onChange={(e) => handleFinishDateCustom(item.id, e.target.value)}
                                                        value={formatDateForInput(item.start_date, false, true)}  // datetime-local format (yyyy-MM-ddTHH:mm:ss)
                                                    /> :
                                                    <span>{(formattedDate !== '01/01/1970') && formattedDate}</span>}
                                            </div>
                                        </td>);
                                    }
                                    if (header === 'finish_date') {
                                        return (<td>
                                            <div className={'input-time-container'}>
                                                <input
                                                    className={'input-time input'}
                                                    type={"datetime-local"}
                                                    max={formatDateForInput(new Date(), false, true)}
                                                    onChange={(e) => handleFinishDate(item.id, e.target.value)}
                                                    value={formatDateForInput(item.finished_at, false, true)}  // datetime-local format (yyyy-MM-ddTHH:mm:ss)
                                                />
                                            </div>
                                        </td>);
                                    }
                                    if (header === 'time_spent') {
                                        return (<td>
                                            <div className="input-time-container">
                                                {((parseInt(localStorage.user_id)) === parseInt(item.user_id) || localStorage.user_role === 'Administrateur') && (
                                                    <TimeInput item={item}
                                                               handleTimeSpent={(time) => handleTimeSpent(item.user_id, time, item.id)}/>)}
                                            </div>
                                        </td>);
                                    }

                                    if (header === 'start_date') {
                                        return (<td>
                                            <div className={'input-time-container'}>

                                                <span>{formatDateForInput(item.start_date, true)}</span>

                                            </div>
                                        </td>);
                                    }
                                    return (<td key={colIndex}>
                                        <p className="t-0 d-ib">{item[header]}</p>
                                    </td>);
                                })}
                            </tr>))}
                        </tbody>


                    </table>

                    {selectedTaskIds.length > 0 && (

                        <div className="adminbar-tasks p-10">
                            <div
                                className="adminbar-inner display-flex gap-20 align-items-center  justify-content-space-between">
                                <div className={"display-flex gap-20"}>
                                    <div className="display-flex align-items-center gap-10"
                                         style={{width: 400}}>
                                        <span>Assigner à :</span>
                                        <select
                                            className="input"
                                            style={{padding: "10px 5px", fontFamily: "Montserrat", width: "auto"}}
                                            value={bulkUserId}
                                            onChange={(e) => handleBulkAssignChange(e.target.value)}
                                            disabled={isBulkWorking}
                                        >
                                            <option value="">Choisir un utilisateur…</option>
                                            {users.map(u => (<option key={u.id} value={u.id}>{u.firstname}</option>))}
                                        </select>
                                        {isBulkWorking && <span>Assignation en cours…</span>}
                                    </div>
                                    <div className="display-flex align-items-center gap-10"
                                    >
                                        <span>Définir la date de fin :</span>
                                        <input
                                            className="input-time input"
                                            type="datetime-local"
                                            style={{padding: "10px 5px", fontFamily: "Montserrat", width: "300px"}}
                                            value={bulkFinishDate}
                                            onChange={(e) => handleBulkFinishDateChange(e.target.value)}
                                            // optional: prevent selecting future dates at the UI level, your API already guards this
                                            max={formatDateForInput(new Date(), false, true)}
                                        />
                                    </div>
                                </div>
                                <div className={"display-flex"}>
                                    <button
                                        style={{height: 40, cursor: "pointer"}}
                                        className="btn btn-secondary"
                                        onClick={() => setSelectedTaskIds([])}
                                        disabled={isBulkWorking}
                                    >
                                        Vider la sélection
                                    </button>
                                </div>
                            </div>
                        </div>)}
                </div>}
            </div>
        </div>
    </div>;
};

export default Tasks;
